/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_DescriptionInputs */

const et_audit_description = /** @type {(inputs: Audit_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telli tasuta veebilehe SEO audit. Selgitame välja, miks su leht ei saa piisavalt päringuid ja kuidas seda parandada.`)
};

const en_audit_description = /** @type {(inputs: Audit_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request a free website SEO audit. We identify why your site isn't getting enough inquiries and how to fix it.`)
};

/**
* | output |
* | --- |
* | "Request a free website SEO audit. We identify why your site isn't getting enough inquiries and how to fix it." |
*
* @param {Audit_DescriptionInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const audit_description = /** @type {((inputs?: Audit_DescriptionInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_DescriptionInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_audit_description(inputs)
	return en_audit_description(inputs)
});